import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=6b303830&scoped=true&"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js&"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCompleted.vue?vue&type=style&index=0&id=6b303830&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b303830",
  null
  
)

export default component.exports